import { memo } from 'react';

/** Small SVG line of WPM per second across a run. */
function WpmChart({ points, isBn }) {
    if (!points || points.length < 2) return null;
    const W = 520;
    const H = 120;
    const pad = { l: 30, r: 8, t: 10, b: 18 };
    const maxWpm = Math.max(20, ...points.map((p) => p.wpm));
    const maxSec = points[points.length - 1].sec || 1;
    const x = (sec) => pad.l + (sec / maxSec) * (W - pad.l - pad.r);
    const y = (wpm) => pad.t + (1 - wpm / maxWpm) * (H - pad.t - pad.b);
    const path = points.map((p, i) => `${i ? 'L' : 'M'}${x(p.sec).toFixed(1)} ${y(p.wpm).toFixed(1)}`).join(' ');
    const area = `${path} L${x(maxSec).toFixed(1)} ${H - pad.b} L${pad.l} ${H - pad.b} Z`;

    return (
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full" role="img">
            {[0, 0.5, 1].map((f) => (
                <g key={f}>
                    <line x1={pad.l} x2={W - pad.r} y1={y(maxWpm * f)} y2={y(maxWpm * f)} strokeWidth="1" className="stroke-[#EEE9E4] dark:stroke-zinc-800" />
                    <text x={pad.l - 5} y={y(maxWpm * f) + 3} textAnchor="end" className="fill-[#B3ABA3] text-[9px]">{Math.round(maxWpm * f)}</text>
                </g>
            ))}
            <path d={area} fill="rgba(230,138,0,0.12)" />
            <path d={path} fill="none" stroke="#e68a00" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
            <text x={W - pad.r} y={H - 4} textAnchor="end" className="fill-[#B3ABA3] text-[9px]">{isBn ? 'সেকেন্ড' : 'seconds'}</text>
        </svg>
    );
}

export default memo(WpmChart);
